import type {
  CrbMarketingUserOnboardingFormDataV1_2,
  CrbMarketingUserOnboardingFormDataV1_3,
  FeatheryForm,
  InputMarketingOrgRegistration
} from '@gcv/shared';
import { UserInterestFeatheryInterestMap } from '@gcv/shared';
import { inject, injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';

import { UsersApi } from 'api';
import { UserStore } from 'stores/UserStore';

export interface PM {
  formData: CrbMarketingUserOnboardingFormDataV1_2 | CrbMarketingUserOnboardingFormDataV1_3;
}

@injectable()
export class CrbWelcomeRepo {
  @inject(UsersApi)
  usersApi: UsersApi;

  @inject(UserStore)
  userStore: UserStore;

  constructor() {
    makeAutoObservable(this);
  }

  programmersModel: PM = { formData: {} };

  public load = async (formId: FeatheryForm) => {
    let form_response = (await this.usersApi.getUserFeatheryFormResponse(this.userStore.user.id, formId))
      ?.form_response;

    // if they haven't filled out interests, but have interests saved on the user, prefill form
    if (!form_response?.interests_1 && this.userStore.user.interests) {
      const interests = this.userStore.user.interests.map((i) => UserInterestFeatheryInterestMap[i]);
      form_response = { ...form_response, interests_1: interests };
    }

    this.programmersModel = { ...this.programmersModel, formData: form_response };
  };

  /**
   * @deprecated This can be deprecated after the recommendedOffers flag is turned on
   */
  public updateUserFeatheryFormResponseOld = async (
    formResponse: CrbMarketingUserOnboardingFormDataV1_2,
    formId: FeatheryForm
  ) => {
    const comment = formResponse['comment_1'] ?? '';
    formResponse['comment_1'] = comment.trim();

    return this.usersApi.updateUserFeatheryFormResponse(this.userStore.user.id, formResponse, formId);
  };

  public updateUserFeatheryFormResponse = async (
    formResponse: CrbMarketingUserOnboardingFormDataV1_3,
    formId: FeatheryForm
  ) => {
    const comment = formResponse['comment_2'] ?? '';
    formResponse['comment_2'] = comment.trim();

    return this.usersApi.updateUserFeatheryFormResponse(this.userStore.user.id, formResponse, formId);
  };

  public registerMarketingUserOrg = async (data: InputMarketingOrgRegistration) =>
    this.usersApi.registerMarketingUserOrg(this.userStore.user.id, data);
}
